import { LoanCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../shared/components/Text';

export const programFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.36,
    field: 'program',
    sortable: false,
    headerName: <Text tId={'PROGRAM'} />,
    align: 'left',
    renderCell: (rowData: { row: LoanCriteria }) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          whiteSpace: 'normal',
          lineHeight: 1.2,
        }}
      >
        <Text tId={rowData.row.loanConditions.program.name} />
      </div>
    ),
  };
};
